// File#: _2_points-of-interest
// Usage: codyhouse.co/license
(function() {
    function initPoi(element) {
      element.addEventListener('click', function(event){
        var poiItem = event.target.closest('.js-points-of-interest__item');
        if(poiItem) poiItem.classList.add('points-of-interest__item--visited');
      });
    };
  
    var poi = document.getElementsByClassName('js-points-of-interest');
    for(var i = 0; i < poi.length; i++) {
      (function(i){initPoi(poi[i]);})(i);
    }
  }());